import { Header } from '../header';

interface BaseLayoutProps {
  children: React.ReactNode;
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  return (
    <>
      <div className='mx-auto w-full max-w-[1728px]'>
        <Header />
        <main className='relative mx-auto px-0 pt-0 md:px-6'>
          <div className='flex w-full flex-col px-5 md:px-0'>{children}</div>
        </main>
      </div>
    </>
  );
};
